import invariant from 'react-utils/invariant';
import { getId, getType } from './responderKeyGetters';
export const responderKeyInvariant = responderKey => {
  const id = getId(responderKey);
  const type = getType(responderKey);
  const parsedId = parseInt(id, 10);
  invariant(!!id, 'Responder ID must be set in the key map');
  invariant(typeof parsedId === 'number' && !isNaN(parsedId), 'Expected id to be parsable as a number not a %s. id was "%s".', typeof id, id);
  invariant(!!type, 'Responder type must be set in the key map');
};